import React from 'react';

import MobileApp from '../media/mobile-app';
import WebApp from '../media/web-app';
import Website from '../media/website';

class ServiceListing extends React.PureComponent {
  render() {
    const { items } = this.props;
    return (
      <section id="services">
        <MobileApp key="1" item={items[0]} />
        <WebApp key="2" item={items[1]} />
        <Website key="3" item={items[2]} />
      </section>
    );
  }
}

const media1 = {
  description: 'We create dedicated native apps for each platform. Apps that look and feel tailored made for the platform while keeping a consistent look between platforms.',
};

const media2 = {
  title: ['Web Apps'],
  description: 'Either as a standalone app or combined with mobile apps, we make web apps that are easy to use and work on all devices.',
};

const media3 = {
  title: ['Websites'],
  description: 'Beautifully responsive design that looks good on all devices regardless of size and platform. Our website designs will make your brand stand out of the crowd.',
};

ServiceListing.defaultProps = {
  items: [
    media1,
    media2,
    media3,
  ],
};

export default ServiceListing;



// WEBPACK FOOTER //
// ./src/components/service-listing/index.js